export default function ProductInfo() {
  return (
    <section className="py-20 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            제품 정보
          </h2>
          <p className="text-lg text-gray-600">
            정확한 정보를 투명하게 제공합니다.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* 왼쪽: 제품 이미지 */}
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/b1a39ea23d281d9e4c5c5a2c80dddc28.jpg"
              alt="화악산 포도즙 제품 상세"
              className="w-full h-auto rounded-2xl shadow-xl"
            />
          </div>

          {/* 오른쪽: 상세 정보 */}
          <div className="space-y-8">
            {/* 원재료 및 원산지 */}
            <div className="bg-white rounded-xl p-6 border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-file-list-line text-[#6B4E9C]"></i>
                원재료 및 원산지
              </h3>
              <div className="space-y-3 text-gray-700">
                <div className="flex justify-between">
                  <span className="font-semibold">원재료</span>
                  <span>포도 100% (국내산)</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">원산지</span>
                  <span>경기도 가평군 화악산 일대</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">품종</span>
                  <span>캠벨얼리, MBA</span>
                </div>
              </div>
            </div>

            {/* 영양 성분 */}
            <div className="bg-white rounded-xl p-6 border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-heart-pulse-line text-[#6B4E9C]"></i>
                영양 성분 (100mL 기준)
              </h3>
              <div className="space-y-3 text-gray-700">
                <div className="flex justify-between">
                  <span className="font-semibold">열량</span>
                  <span>68 kcal</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">탄수화물</span>
                  <span>16.8 g</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">당류</span>
                  <span>15.2 g</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">단백질</span>
                  <span>0.6 g</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">나트륨</span>
                  <span>2 mg</span>
                </div>
              </div>
            </div>

            {/* 제품 특성 */}
            <div className="bg-white rounded-xl p-6 border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-information-line text-[#6B4E9C]"></i>
                제품 특성
              </h3>
              <div className="space-y-3 text-gray-700">
                <div className="flex justify-between">
                  <span className="font-semibold">당도</span>
                  <span>14~16 °Brix</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">맛 노트</span>
                  <span>산뜻한 신맛, 자연스러운 단맛</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">색상</span>
                  <span>진한 자주색</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold">향</span>
                  <span>포도 본연의 향</span>
                </div>
              </div>
            </div>

            {/* 보관 방법 */}
            <div className="bg-white rounded-xl p-6 border border-gray-200">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-fridge-line text-[#6B4E9C]"></i>
                보관 방법
              </h3>
              <div className="space-y-3 text-gray-700">
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
                  <span>냉장 보관 (0~10°C)</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
                  <span>개봉 후 즉시 섭취 권장</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-check-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
                  <span>유통기한: 제조일로부터 6개월</span>
                </div>
              </div>
            </div>

            {/* 알레르기 정보 */}
            <div className="bg-amber-50 rounded-xl p-6 border border-amber-200">
              <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
                <i className="ri-alert-line text-amber-600"></i>
                알레르기 정보
              </h3>
              <p className="text-gray-700">
                본 제품은 포도만을 원재료로 사용하며, 다른 알레르기 유발 물질을 포함하지 않습니다.
              </p>
            </div>

            {/* 무첨가 강조 */}
            <div className="bg-gradient-to-r from-[#6B4E9C]/10 to-purple-100/30 rounded-xl p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                무첨가 원칙
              </h3>
              <div className="grid grid-cols-3 gap-4 text-center">
                <div>
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full mx-auto mb-2">
                    <i className="ri-close-circle-line text-2xl text-[#6B4E9C]"></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">물 0%</p>
                </div>
                <div>
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full mx-auto mb-2">
                    <i className="ri-close-circle-line text-2xl text-[#6B4E9C]"></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">설탕 0%</p>
                </div>
                <div>
                  <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full mx-auto mb-2">
                    <i className="ri-close-circle-line text-2xl text-[#6B4E9C]"></i>
                  </div>
                  <p className="text-sm font-semibold text-gray-900">향료 0%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}